export const MARGIN = { top: 0, right: 0, bottom: 0, left: 0 };

export const CHART_SIZE = { width: 144, height: 144 };
